/* tslint:disable */
/* eslint-disable */
/**
 * Swagger wiegaaterkoffiehalen
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.3.5
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppCheck
 */
export interface AppCheck {
    /**
     * 
     */
    minBuildVersion: string;
    /**
     * 
     */
    appStoreUrl: string;
    /**
     * 
     */
    googlePlayUrl: string;
}

/**
 * Check if a given object implements the AppCheck interface.
 */
export function instanceOfAppCheck(value: object): value is AppCheck {
    if (!('minBuildVersion' in value) || value['minBuildVersion'] === undefined) return false;
    if (!('appStoreUrl' in value) || value['appStoreUrl'] === undefined) return false;
    if (!('googlePlayUrl' in value) || value['googlePlayUrl'] === undefined) return false;
    return true;
}

export function AppCheckFromJSON(json: any): AppCheck {
    return AppCheckFromJSONTyped(json, false);
}

export function AppCheckFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppCheck {
    if (json == null) {
        return json;
    }
    return {
        
        'minBuildVersion': json['minBuildVersion'],
        'appStoreUrl': json['appStoreUrl'],
        'googlePlayUrl': json['googlePlayUrl'],
    };
}

export function AppCheckToJSON(json: any): AppCheck {
    return AppCheckToJSONTyped(json, false);
}

export function AppCheckToJSONTyped(value?: AppCheck | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'minBuildVersion': value['minBuildVersion'],
        'appStoreUrl': value['appStoreUrl'],
        'googlePlayUrl': value['googlePlayUrl'],
    };
}

